import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes/AppRoutes";
import "moment/locale/ar";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SplashScreen from "./pages/SplashScreen/SplashScreen";
import { ScrollToTop } from "./components";
import SEO from "./api/Seo/SEO";

function App() {
  const [isSplashVisible, setIsSplashVisible] = useState(false);
  const { i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2);
  useEffect(() => {
    setIsSplashVisible(true);
    const timer = setTimeout(() => {
      setIsSplashVisible(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  if (isSplashVisible) {
    return <SplashScreen />;
  }

  return (
    <div
      className={`min-h-[100dvh] max-w-[100vw] ${lang == "ar" ? "arabic" : ""}`}
    >
      <SEO />
      <Router>
        <ScrollToTop />
        <Routes />
      </Router>
    </div>
  );
}

export default App;
